import React from "react";

const UrbaniaVisionMission = () => {
  return (
    <div className="uvm-section">
      <div className="uvm-container">
        <h2 className="uvm-title">Our Vision & Mission</h2>

        <div className="uvm-grid">

          {/* Vision */}
          <div className="uvm-card vision">
            <div className="uvm-icon-box">🚌</div>
            <h3>Our Vision</h3>
            <p>
              To be the most trusted and preferred Urbania rental service in Pune by delivering safe, comfortable, and reliable travel experiences. 
              We aim to redefine group and family travel by combining luxury, punctuality, and convenience for every journey.
            </p>
            <p>
              Our vision is to set new benchmarks in Pune’s transportation sector by focusing on customer satisfaction, expanding our fleet, and continuously enhancing service quality for seamless travel experiences.
            </p>
          </div>

          {/* Mission */}
          <div className="uvm-card mission">
            <div className="uvm-icon-box">🎯</div>
            <h3>Our Mission</h3>
            <p>
              Our mission is to provide hassle-free Urbania rentals in Pune with well-maintained vehicles and professional drivers. 
              We are committed to safety, timely pickups, and ensuring every trip is smooth, stress-free, and enjoyable.
            </p>
            <p>
              We strive to build lasting relationships with our customers through transparent pricing, responsive support, and continuous improvements driven by feedback and innovation.
            </p>
          </div>

        </div>
      </div>
    </div>
  );
};

export default UrbaniaVisionMission;